import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-date-picker-input',
  templateUrl: './date-picker-input.component.html',
  styleUrl: './date-picker-input.component.scss'
})
export class DatePickerInputComponent implements OnInit, OnChanges {
  @Input() name: string = '';
  @Input() label: string = '';
  @Input() value: number = 0;
  @Input() required: boolean = false;
  @Input() hideOptional: boolean = false;
  @Input() error: boolean = false;
  @Input() disabled: boolean = false;
  @Input() inlineInfo: string = '';
  @Input() errorText: string = 'This field is required.';
  @Input() showLabel: boolean = true;
  @Output() valueChange = new EventEmitter<number>();

  dateValue: Date | null = null;


  ngOnChanges(changes: SimpleChanges) {
    if (!!changes['value']) {
      this.convertValueToDate()
    }
  }

  ngOnInit() {
    this.convertValueToDate()
  }

  convertValueToDate() {
    if (this.value) {
      this.dateValue = new Date(Number(this.value));
    }
  }

  updateValue(value: Date) {
    if (value) {
      this.dateValue = value;
      this.value = value.getTime();
      this.valueChange.emit(this.value);
    } else {
      this.dateValue = null;
      this.value = 0;
      this.valueChange.emit(this.value);
    }
  }
}
